import React from 'react';
import AttributesInterface from 'interfaces/attributes.interface';
import ProducerInterface from 'interfaces/producer.interface';

import './product-attributes.scss';

interface ProductAttributesProps {
    attributes: AttributesInterface[];
    producer: ProducerInterface;
    maxItems?: number;
}

const ProductAttributes: React.FC<ProductAttributesProps> = ({ maxItems = 0, attributes, producer }) => {
    const attributeList = [...attributes];

    if (producer?.name) {
        attributeList.unshift({ label: 'Producent', value: producer.name });
    }

    if (!attributeList.length) {
        return null;
    }

    const filterAttributeList = (attribute: AttributesInterface, index: number): boolean => {
        return attribute.label !== '' && (!maxItems || index < maxItems);
    };

    return (
        <table className="product-attributes">
            <tbody>
                {attributeList.filter(filterAttributeList).slice(0, 8).map((attribute) => (
                    <tr key={attribute.value}>
                        <td className="product-attributes--label">
                            {attribute.label}
                        </td>
                        <td className="product-attributes--value" title={attribute.value}>
                            {attribute.value}
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default ProductAttributes;
